export default __webpack_public_path__ + "ac6e7dc93ed9cee516d293dfcc055489.svg";